import viewPassword from "./view-password.svg";
import hidePassword from "./hide-password.svg";
const frameworkIcons = {
  viewPassword,
  hidePassword,
};
export default frameworkIcons;
